import React from 'react'
import GenericMultiActivityDashboard from '../generic/GenericMultiActivityDashboard'
import { collectionSubTypes, collectionTypes, timeSeries } from '../../../common/Constants'
import I18n from 'i18n'
import { seasonRunningMetric } from '../../../common/Units'
import Variables from '../../../../../javascript/stylesheets/variables.module.scss'
const { primaryColor, secondaryColor } = Variables

const RunningDashboardMulti = props => {
  const fields = [
    'avg_distance_per_week',
    'avg_duration_per_week',
    'avg_trainings_per_week',
    'avg_elevation_per_week',
    'avg_hr',
    'max_hr',
    'avg_speed',
    'max_speed'
  ]

  const categories = [
    { name: collectionSubTypes.GENERIC_SUBTYPE, color: secondaryColor, label: I18n.t('components.dashboards.multi_activity.type.outdoors') },
    { name: collectionSubTypes.INDOOR_RUNNING, color: primaryColor, label: I18n.t('components.dashboards.multi_activity.type.indoors') }
  ]

  const intensityMetrics = [
    { value: timeSeries.HR, name: I18n.t('components.dashboards.multi_activity.intensity.hr') }
  ]

  return (
    <GenericMultiActivityDashboard
      title={I18n.t('components.dashboards.running.title')}
      seasonFields={fields}
      collectionType={collectionTypes.RUNNING}
      categories={categories}
      intensityMetrics={intensityMetrics}
      seasonUnitsTable={seasonRunningMetric}
      {...props}
    />
  )
}

export default RunningDashboardMulti
